import React, { useEffect, useState } from "react";
import { ReactComponent as Checked } from "~/assets/images/dashboard/Checked.svg";
import { ReactComponent as Unchecked } from "~/assets/images/dashboard/Unchecked.svg";
import classNames from 'classnames';


const LinearProgressBar = ({ start, end, progress, reward })=> {

  const [width, setWidth] = useState(0);

  useEffect(()=> {
    if((progress > start) && (width < Math.floor(progress/end * 100))) {
      if(progress < end) setWidth( Math.floor((progress)/end * 100) < 25 ? 25 : Math.floor((progress)/end * 100)  );
      else setWidth(100);
    }
  }, [start, end, progress, reward ]);

  return (
    <div className="progress-wrapper">
      <div className="progress-bar-container">
        <div className="filler" style={{transition: 'width 0.8s ease-in-out', width: `${ width }%`}}>
          <span className="start">{ start }</span>
          {reward && <span className="label">{`${(progress > start && progress <= end) ? `day ${progress}` : ''}`}</span> }
        </div>
        <div className="end">{ end }</div>
      </div>
      <div className="reward">
      {reward && 
        <div className={classNames("points-reward", {passed: progress >= end})}>
          { reward.points    ? `+${reward.points}pt` : '' }
          { reward.percentage? `+${reward.percentage}%` : ''}
        </div>
      }
        {progress >= end ? <Checked style={{marginLeft: reward ? "0px" : "5px"}}/> : <Unchecked style={{marginLeft: reward ? "0px" : "5px"}}/> }
      </div>
    </div>
  );
};

export default LinearProgressBar;
